export default {
  footerLink: 'Definições de cookies',
  consentModal: {
    title: 'Utilizamos cookies',
    description: 'Utilizamos um conjunto mínimo de cookies para o funcionamento do site, além de cookies opcionais de análise e publicidade — apenas com o seu consentimento.',
    acceptAllBtn: 'Aceitar tudo',
    acceptNecessaryBtn: 'Rejeitar tudo',
    showPreferencesBtn: 'Gerir preferências',
  },
  preferencesModal: {
    title: 'Preferências de cookies',
    acceptAllBtn: 'Aceitar tudo',
    acceptNecessaryBtn: 'Rejeitar tudo',
    savePreferencesBtn: 'Guardar preferências',
    closeIconLabel: 'Fechar',
    sections: [
      {
        title: 'Necessários',
        description: 'Estes cookies são necessários para o funcionamento do site e não podem ser desativados.',
        linkedCategory: 'necessary',
      },
      {
        title: 'Análise',
        description: 'Ajudam-nos a perceber como o site é utilizado para podermos melhorá-lo.',
        linkedCategory: 'analytics',
      },
      {
        title: 'Publicidade',
        description: 'Utilizados para tornar os anúncios mais relevantes. Apenas ativados com o seu consentimento.',
        linkedCategory: 'ads',
      },
    ],
  },
}
